import type { IconSet, SvgIcon } from '../types/components';

export const UNKNOWN_ICON = {
  icon: {
    paths: [
      'm256 336a24 24 0 1 0 24 24 24.027 24.027 0 0 0 -24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1 -8 8z',
      'm448 120a8 8 0 0 0 -2.343-5.657l-96-96a8 8 0 0 0 -5.657-2.343h-240a40.045 40.045 0 0 0 -40 40v400a40.045 40.045 0 0 0 40 40h304a40.045 40.045 0 0 0 40-40zm-96-76.687 68.687 68.687h-44.687a24.027 24.027 0 0 1 -24-24zm80 412.687a24.028 24.028 0 0 1 -24 24h-304a24.028 24.028 0 0 1 -24-24v-400a24.028 24.028 0 0 1 24-24h232v56a40.045 40.045 0 0 0 40 40h56z',
      'm256 160a64.072 64.072 0 0 0 -64 64 8 8 0 0 0 16 0 48 48 0 1 1 48 48 8 8 0 0 0 -8 8v32a8 8 0 0 0 16 0v-24.5a64 64 0 0 0 -8-127.5z',
    ],
    width: 512,
    attrs: [{}, {}, {}, {}, {}],
  },
  properties: {
    name: 'unknown',
  },
};

export const findIcon = (name: string, iconSet: IconSet): SvgIcon =>
  iconSet.icons.find((iconEl) => iconEl.properties.name.split(', ').includes(name)) || UNKNOWN_ICON;
